import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./../public/locales/en.json";
import eng from "./../public/locales/eng.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    eng: { translation: eng },
    // hi: { translation: hi },
    // fr: { translation: fr }
  },
  lng: "en", // default
  fallbackLng: ["en", "eng"],
  interpolation: { escapeValue: false }
});

export default i18n;
